import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { isEmbeddedInIframe, isLocalEnvironment } from './app/shared/utils/app-access.util';
import { environment } from './environments/environment';

// Outside localhost, this app must only be opened inside StaffInterface's iframe.
// Direct access redirects to StaffInterface instead of bootstrapping the app.
if (!isLocalEnvironment() && !isEmbeddedInIframe() && environment.staffInterfaceUrl) {
    window.location.replace(environment.staffInterfaceUrl);
} else {
    bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
}
